import React from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { CDN_BASE_URL } from "../../config";

const BlogSlider = ({ data }) => {
  return (
    <div>
      <Swiper autoplay={{ delay: 3000 }} modules={[Autoplay]} loop={data?.length > 1}>
        {data?.length > 4
          ? data?.slice(0, data?.length - 1)?.map((e) => (
              <SwiperSlide>
                <Link to={"/blogs/" + e?.url}>
                  <img
                    src={CDN_BASE_URL + e.cover}
                    alt={e.name}
                    title={e.name}
                    
                    className="w-full max-h-[414px] object-cover my-10 rounded-[10px] center"
                  />
                </Link>
              </SwiperSlide>
            ))
          : data?.map((e) => (
              <SwiperSlide>
                <Link to={"/blogs/" + e?.url}>
                  <img
                    src={CDN_BASE_URL + e.cover}
                    alt={e.name}
                    title={e.name}
                    className="w-full max-h-[414px] object-cover my-10 rounded-[10px] center"
                  />
                </Link>
              </SwiperSlide>
            ))}
      </Swiper>

      <div className="grid grid-cols-4 gap-5">
        {data?.length > 4 &&
          data?.slice(data?.length - 4, data.length - 1)?.map((e) => (
            <span>
              <Link to={"/blogs/" + e?.url}>
                <img
                  src={CDN_BASE_URL + e.cover}
                  className="w-full rounded-[10px]"
                  alt={e.name}
                  title={e.name}
                />
              </Link>
            </span>
          ))}
      </div>
    </div>
  );
};

export default BlogSlider;
